import { useActive, useCommands } from "@remirror/react";
import { CommandMenuItem, DropdownButton } from "@remirror/react-ui";
import { COLORS, COLORS_LABEL } from "../../../../constants";
import { getColorDotStyling } from "../../../../utils";
import { useEffect } from "react";
import { TextProps } from "../../../../types";
import { TextColorIcon } from "./TextColorIcon";

const ariaLabel = "Text color";

export const TextColorButtons = ({ toggleButton, onBlur }: TextProps) => {
  const { setTextColor } = useCommands();
  const { textColor } = useActive();
  const currentTextColor = COLORS.find((color) => textColor({ color }));

  useEffect(() => {
    toggleButton({
      shouldSelect: Boolean(currentTextColor),
      ariaLabel,
    });
  }, [currentTextColor, toggleButton]);

  return (
    <DropdownButton
      aria-label={ariaLabel}
      icon={<TextColorIcon lineColor={currentTextColor} />}
    >
      {COLORS.map((color) => (
        <CommandMenuItem
          key={color}
          commandName="setTextColor"
          onSelect={() => {
            setTextColor(color);
            onBlur();
          }}
          enabled={setTextColor.enabled(color)}
          active={textColor({ color })}
          label={COLORS_LABEL[color]}
          icon={<div style={getColorDotStyling(color)} />}
          displayDescription={false}
        />
      ))}
    </DropdownButton>
  );
};
